import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=4f99481e&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99481e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f99481e')) {
      api.createRecord('4f99481e', component.options)
    } else {
      api.reload('4f99481e', component.options)
    }
    module.hot.accept("./indexCopy.vue?vue&type=template&id=4f99481e&scoped=true", function () {
      api.rerender('4f99481e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/returnNoteRecord/indexCopy.vue"
export default component.exports